export default function joinClassNames(...names) {
  return names.filter(Boolean).join(' ');
}
